// import { BrowserRouter } from "react-router-dom";
// import { AppRoutes } from "./router";
// import { I18nextProvider } from "react-i18next";
// import i18n from "./i18n";
// import { AuthProvider } from "./context/AuthContext";
// // import { ToastContainer } from "react-toastify";
// import ToastProvider  from "./authFlow/context/pages";


// function App() {
//   return (
//     <I18nextProvider i18n={i18n}>
//       <BrowserRouter basename={__BASE_PATH__}>
      
//        <ToastProvider>
//       <AuthProvider>
//         <AppRoutes />
//       </AuthProvider>
//        </ToastProvider>
      
//       </BrowserRouter>
//     </I18nextProvider>
//   );
// }

// export default App;



import React from 'react'
import { BrowserRouter } from 'react-router-dom';
import i18n from "./i18n";
import { ToastContainer } from "react-toastify";
import { AppRoutes } from './router'
import { AuthProvider } from './context/AuthContext'
import { I18nextProvider } from 'react-i18next';
import WhatsAppButton from './components/WhatsAppButton';

export default function App() {
  return (
    <>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
    <AuthProvider>
        <AppRoutes />

        <WhatsAppButton />
      </AuthProvider>
      </BrowserRouter>
      
    </I18nextProvider>
    
    </>
    
   
  )
}
